var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"align-start",style:(_vm.footerStyle)},[_c('v-container',{staticClass:"footer-container",attrs:{"fluid":""}},[_c(_vm.currentFooterComponent,{tag:"component",on:{"openTextDialog":_vm.openTextDialog}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }